import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import { verifyEmail } from "../../../services/user";
import PageExpired from "../messages/PageExpired";

export class EmailVerify extends Component {
    state = {
        validToken: true
    };

    componentDidMount() {
        verifyEmail({ token: this.props.match.params["token"] })
            .then(res => {
                if (res.status === true) {
                    //this.props.history.push("/login");
                    if (res.data.steps == 'writing-jobs' && localStorage.getItem("user_steps") == 'writing-jobs') {
                        this.props.history.push("/process/writingjobs");
                    } else if (res.data.steps == 'billing' && localStorage.getItem("user_steps") == 'billing') {
                        this.props.history.push("/process/step3");
                    } else if (res.data.steps == 'account' && localStorage.getItem("user_steps") == 'account') {
                        this.props.history.push("/account");
                    } else {
                        this.props.history.push("/login");
                    }
                } else {
                    this.setState({ validToken: false });
                }
            })
            .catch(error => {
                this.setState({ validToken: false });
            });
    }

    render() {
        return !this.state.validToken ? <PageExpired></PageExpired> : null;
    }
}
EmailVerify.contextType = AppContext;
export default EmailVerify;



// WEBPACK FOOTER //
// ./src/components/auth/email/Verify.js